import { vsName as serverUtilityName } from "../../../../records/server/serverUtility";
import { vsName as csvWriterName } from "../../../../records/csv/csvWriter";

export const vsName = "mealLogDownloadService";

export class MealLogDownloadService {
  constructor(serverUtility, csvWriter, longDateFormatFilter) {
    this.serverUtility = serverUtility;
    this.csvWriter = csvWriter;
    this.longDateFormatFilter = longDateFormatFilter;
    this.columns = [
      {
        field: "SerialNumber",
        header: "Serial Number",
      },
      {
        field: "SlotNumber",
        header: "Slot Number",
      },
      {
        field: "MealLogReasonName",
        header: "Category",
      },
      {
        field: "UserName",
        header: "Employee",
      },
      {
        field: "Notes",
        header: "Notes",
      },
      {
        field: "OpenedDate",
        header: "Opening Date",
        formatter: (params) => this.longDateFormatFilter(params.row.OpenedDate),
      },
      {
        field: "ClosedDate",
        header: "Closing Date",
        formatter: (params) => this.longDateFormatFilter(params.row.ClosedDate),
      },
    ];
  }

  downloadCsvForMachine(machine) {
    this.serverUtility
      .fetchAllLegacy({
        url: `/api/machines/${machine.Id}/MealLog`,
        query: {},
      })
      .then((rows) => {
        rows.forEach(r => {
          r.SerialNumber = machine.SerialNumber
          r.SlotNumber = machine.SlotNumber
          r.UserName = r.CreatedByName
        })
        this.writeCsv(rows)
      });
  }

  downloadCsvFromQuery(query) {
    this.serverUtility
      .fetchAllLegacy({ url: "/api/machines/getAllMealLogs", query })
      .then((rows) => {
        this.writeCsv(rows);
      });
  }

  writeCsv(rows) {
    const csvConfig = {
      columns: this.columns,
      includeHeaders: true,
    };
    const csv = this.csvWriter.getCsv(csvConfig, rows);
    this.csvWriter.saveFile({ content: csv, filename: "mealLog.csv" });
  }
}
MealLogDownloadService.$inject = [
  serverUtilityName,
  csvWriterName,
  "longDateFormatFilter",
];
